import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { aboutStats } from "../mockData";

// Number animation
const CountUp = ({ end, duration = 2 }) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration * 60);

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(counter);
      }
      setValue(Math.floor(start));
    }, 1000 / 60);

    return () => clearInterval(counter);
  }, [end, duration]);

  return value.toLocaleString();
};

const AboutSection = () => {
  return (
  <section className="pt-10 md:pt-0 pb-0 px-4 sm:px-6 bg-transparent scale-[0.9] md:scale-[0.94]">
      
      <div className="max-w-[1200px] mx-auto">

        {/* ★ About Badge */}
        <motion.div
          className="flex justify-center mb-10 mb-5"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center gap-2 md:mb-[0px] px-4 py-2.5 bg-white rounded-[40px] border border-dashed border-neutral-300 shadow-sm h-[35px]">
            <svg width="10" height="10" viewBox="0 0 256 256" fill="#3C5DF7" className="animate-spin" style={{ animationDuration: '5s' }}>
              <path d="M240,128a15.79,15.79,0,0,1-10.5,15l-63.44,23.07L143,229.5a16,16,0,0,1-30,0L89.94,166.06,26.5,143a16,16,0,0,1,0-30L89.94,89.94,113,26.5a16,16,0,0,1,30,0l23.07,63.44L229.5,113A15.79,15.79,0,0,1,240,128Z" />
            </svg>
            <span className="text-[17px] font-medium text-gray-700">
              About
            </span>
          </div>
        </motion.div>

        {/* Heading */}
        <motion.h2
          className="
            text-center
            font-black
            max-w-[1000px]
            mx-auto
            text-[#171717]
            mb-10
            tracking-[-3px]
            line-height: 1;
            text-[36px]
            sm:text-[44px]
            md:text-[56px]
          "
          style={{
            fontFamily: `"Plus Jakarta Sans", "Plus Jakarta Sans Placeholder", sans-serif`,
            lineHeight: "1",
            
            
            fontWeight: 700,
          }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
           
          <span className="font-semibold">With years of experience, Bloom Social creates videos that boost</span>
          <span style={{ color: "#3C5DF7", fontFamily: "Recoleta" }}> views</span>
          <span className="font-semibold">, generate</span>
          <span style={{ color: "#3C5DF7", fontFamily: "Recoleta"}}> leads</span>
          <span className="font-semibold">, and strengthen audience</span>
          <span style={{ color: "#3C5DF7", fontFamily: "Recoleta" }}> engagement.</span>
          <br />
          
        </motion.h2>

        {/* Stats Box */}
        <motion.div
          className="flex justify-center mt-15"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div
            className="
            bg-white
            rounded-[22px]
            px-8 py-5
            flex items-center justify-center
            md:gap-16
            gap-10
            border border-dashed border-neutral-300
            shadow-sm
            "
          >
            {aboutStats.map((stat, index) => (
              <div key={index} className="text-center">
                <div
                  className="text-[#3C5DF7] font-bold leading-none mb-2"
                  style={{
                    fontFamily: `"Plus Jakarta Sans", "Plus Jakarta Sans Placeholder", sans-serif`,
                    fontSize: "35px",
                    fontWeight: 100,
                  }}
                >
                  {stat.value.includes('M') ? (
                    stat.value
                  ) : (
                    <>
                      <CountUp end={parseInt(stat.value)} />+
                    </>
                  )}
                </div>
                <div
                  className="text-neutral-600"
                  style={{
                    fontFamily: `"Plus Jakarta Sans", "Plus Jakarta Sans Placeholder", sans-serif`,
                    fontSize: "15px",
                    fontWeight: 500,
                  }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default AboutSection;
